import { BrowserModule } from '@angular/platform-browser';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AppCommonModule } from "./app-common/app-common.module";
import { RestatementModule } from "./internalAdmin/aa-restatement/restatement.module";
import { RetirementPlanDocumentsModule } from "./admin/retirement-plan-documents/retirement-plan-documents.module";

import { AdminAppComponent } from "./_layout/admin/admin.component";
import { PrintDistributionModule } from './admin/retirement-plan-documents/print-distribution/print-distribution.module';
import { MatNativeDateModule } from '@angular/material/core';

import { SafeHarborModule } from "./internalAdmin/safeharbor/safeHarbor.module";
import { SharedModule } from './shared/shared.module';
import { TokenHttpInterceptor, TokenRefreshInterceptor } from './shared/interceptor';
import { AuthService } from './shared/services/auth.service';
import { provideOAuthClient } from 'angular-oauth2-oidc';
import { AppInitialize } from './app-initialize';
import { GemsService } from './shared/services/gems.service';
import { UnauthorizedPageComponent } from './unauthorized-page';
import { EnumInjectionTokens } from './shared/constants';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/Lara';
import { ActivatedRoute, Router } from '@angular/router';

@NgModule({
    declarations: [
        AppComponent,
        AdminAppComponent,
        UnauthorizedPageComponent
    ],
    exports: [],
    bootstrap: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        AppCommonModule,
        RestatementModule,
        FormsModule,
        RetirementPlanDocumentsModule,
        PrintDistributionModule,
        MatNativeDateModule,
        SafeHarborModule
    ],
    providers: [
        provideAnimationsAsync(),
        providePrimeNG({
            theme: {
                preset: Lara,
                options: {
                    darkModeSelector: 'none',
                    cssLayer: {
                        name: 'primeng',
                        order: 'primeng, theme'
                    }
                }
            }
        }),
        provideOAuthClient(),
        provideAppInitializer(() => {
            const initializerFn = (AppInitialize)(
                inject(AuthService),
                inject(GemsService),
                inject(Router),
                inject(ActivatedRoute)
            );
            return initializerFn();
        }),
        { provide: EnumInjectionTokens.Environment, useValue: environment },
        { provide: HTTP_INTERCEPTORS, useClass: TokenHttpInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: TokenRefreshInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule { }
